import { useState } from 'react'
import { TbCalendarEvent } from 'react-icons/tb'
import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Button } from 'ui-kit/actions/button'
import { CALENDLY_WIDGET_URL } from 'routes/constants'
import { CalendlyWidget, Popup } from 'routes/components/Shared'
import classes from './PricingRequestADemo.module.scss'

export function PricingRequestADemo() {
  // const freeTrialTest = useFeatureFlagVariantKey(
  //   'pricing-page-free-trial-conversion',
  // )

  return null
  return <RequestADemoSection />
}

function RequestADemoSection() {
  const [showPopup, setShowPopup] = useState(false)

  const togglePopup = () => setShowPopup((v) => !v)

  return (
    <>
      <Block
        as={'section'}
        variant={'shadow'}
        pad={'base'}
        className={classes.section}
      >
        <div className={classes.description}>
          <Heading as={'h2'} size={'xl'} center balance>
            Get Expert Guidance
          </Heading>
          <Text size={'lg'} center balance className={classes.subtitle}>
            Our team will help you validate requirements and build a working
            prototype of integrations for your use case completely free.
          </Text>
        </div>

        <Button
          className={classes.button}
          category={'secondary'}
          onClick={togglePopup}
        >
          Book PoC consultation
          <TbCalendarEvent className={classes.icon} />
        </Button>
      </Block>
      <Popup onClose={togglePopup} open={showPopup} className={classes.modal}>
        <CalendlyWidget calendlyUrl={CALENDLY_WIDGET_URL} />
      </Popup>
    </>
  )
}
